import {
  EmbedForm,
  getEmbedDescription,
} from "@circle-react-shared/uikit/TipTapBlockEditor/EmbedExtension/EmbedModal/EmbedModalCompass/EmbedForm";
import { Typography } from "@circleco/compass/components/Typography";
import type { ChangeEvent, FormEvent } from "react";

import { t } from "@/i18n-js/instance";

import { EMBED_FORM_ID } from "./constants";

interface EmbedPanelProps {
  error?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
  url: string;
}

export const EmbedPanel = ({
  error,
  onChange,
  onSubmit,
  url,
}: EmbedPanelProps) => {
  const provider = t(
    "tiptap.extensions.embed.provider_description.top_video_providers",
  );

  return (
    <div className="flex flex-col gap-2 pt-2">
      <EmbedForm
        formId={EMBED_FORM_ID}
        url={url}
        error={error}
        onChange={onChange}
        onSubmit={onSubmit}
      />
      <Typography variant="body-sm" color="tertiary" className="px-1">
        {getEmbedDescription(provider)}
      </Typography>
    </div>
  );
};
